import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI,
});

const authLink = setContext((_, { headers }) => {
  const authToken = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      authorization: authToken ? authToken : '',
    },
  };
});

export default new ApolloClient({
  link: authLink.concat(httpLink),
  // uri: "http://localhost:4000/admin-graphql",
  cache: new InMemoryCache(),
});
